<div class="modules-container" @fadeInAnimation>
  <h2 class="text-title-md-bold-upper mb-sm">Módulos</h2>
  <ng-container *ngFor="let item of items; index as index">
    <button *ngIf="!item.hide"
      [ngStyle]="{'pointer-events': item.disabled ? 'none' : 'auto'}"
      [routerLink]="item.route"
      [routerLinkActive]="'selected'"
      [routerLinkActiveOptions]="{exact: item.exact}"
      [queryParams]="item.queryParams"
      (click)="onEmitClickItem(item)"
      [class.disabled]="item.disabled"
      [ngClass]="['panel-item-' + index]"
    >
      <!-- [routerLinkActiveOptions]="{exact: true}" -->
      <div>
        <img loading="lazy" [src]="item.img" class="mr-sm" alt="" />
        <label class="text-subtitle-bold">{{ item.title }}</label>
      </div>
      <div>
        <i nz-icon nzType="caret-right" class="opacity-50" nzTheme="outline"></i>
      </div>
    </button>
  </ng-container>
</div>
